(function () {
  function resolveField(selector) {
    var el = document.querySelector(selector);
    if (!el) return null;

    if (el.matches && el.matches('input, select, textarea')) return el;
    return el.querySelector('input, select, textarea');
  }

  function getValueFrom(selector) {
    var el = document.querySelector(selector);
    if (!el) return '';

    if (el.value !== undefined) return el.value;

    var field = resolveField(selector);
    if (field && field.value !== undefined) return field.value;

    return (el.textContent || '').trim();
  }

  function setValueTo(selector, value) {
    var field = resolveField(selector);

    if (field) {
      field.value = value;
      return true;
    }

    var el = document.querySelector(selector);
    if (el) {
      el.textContent = value;
      return true;
    }

    return false;
  }

  // Devuelve true si el switch "emite_factura" está activo
  function isEmiteFactura() {
    var el = document.querySelector('[name="emite_factura"]');
    if (!el) return false;
    if (el.type === 'checkbox') return el.checked;
    return el.value === '1' || el.value === 'true' || el.value === 'yes';
  }

  // Convierte valor numérico en cualquier formato (es-ES o punto decimal) a float
  function parseRawNumber(value) {
    var str = String(value || '').trim().replace(/[€%\s]/g, '');
    if (!str) return NaN;
    if (str.indexOf(',') !== -1 && str.indexOf('.') !== -1) {
      str = str.replace(/\./g, '').replace(',', '.');
    } else if (str.indexOf(',') !== -1) {
      str = str.replace(',', '.');
    }
    return parseFloat(str);
  }

  function formatES(num) {
    var parts = num.toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return parts[0] + ',' + parts[1];
  }

  function formatMoney(value) {
    var num = parseRawNumber(value);
    if (isNaN(num)) return String(value || '');
    return formatES(num);
  }

  function formatPercent(value) {
    var num = parseRawNumber(value);
    if (isNaN(num)) return String(value || '');
    return formatES(num) + ' %';
  }

  // ✅ Ocultar si vacío o si es "0" en cualquiera de sus formatos típicos
  function shouldHideValue(value) {
    if (value === null || value === undefined) return true;

    var str = String(value).trim();
    if (str === '') return true;

    var num = parseRawNumber(str);
    if (!isNaN(num) && num === 0) return true;

    return false;
  }

  function getRowElementByRowClass(rowClass) {
    var marker = document.querySelector('.' + rowClass);
    if (!marker) return null;
    // Oculta la fila real (contenedor Gutenberg)
    return marker.closest('.wp-block-columns') || marker;
  }

  function hideRow(rowClass) {
    var row = getRowElementByRowClass(rowClass);
    if (!row) return false;
    row.style.setProperty('display', 'none', 'important');
    return true;
  }

  function showRow(rowClass) {
    var row = getRowElementByRowClass(rowClass);
    if (!row) return false;
    row.style.removeProperty('display');
    return true;
  }

  function updateRowsVisibility() {
    // input recibido -> clase fila
    var map = [
      ['valor_inicial_recibido', 'f-valor-inicial'],
      ['precio_venta_recibido', 'f-precio-venta'],
      ['factor_correccion_recibido', 'f-cociente-devaluacion'],
      ['base_imponible_recibido', 'f-base-imponible'],
      ['tipo_impositivo_recibido', 'f-tipo-impositivo'],
      ['itp_recibido', 'f-itp'],
      ['tasa_transfer_dgt_recibido', 'f-transfer-dgt'],
      ['tasa_informe_dgt_recibido', 'f-informe-dgt'],
      ['gestion_tramitacion_recibido', 'f-tramitacion'],
      ['total_recibido', 'f-total'],
    ];

    for (var i = 0; i < map.length; i++) {
      var fieldId = map[i][0];
      var rowClass = map[i][1];

      var field = resolveField('#' + fieldId);
      var value = field ? field.value : '';

      if (shouldHideValue(value)) hideRow(rowClass);
      else showRow(rowClass);
    }
  }

  var FORMAT_MAP = {
    '#valor_inicial_enviado':       'money',
    '#precio_venta_enviado':        'money',
    '#factor_correccion_enviado':   'percent',
    '#base_imponible_enviado':      'money',
    '#tipo_impositivo_enviado':     'percent',
    '#itp_enviado':                 'money',
    '#tasa_transfer_dgt_enviado':   'money',
    '#tasa_informe_dgt_enviado':    'money',
    '#gestion_tramitacion_enviado': 'money',
    '#total_enviado':               'money',
  };

  function applyFormat(sourceSel, value) {
    var fmt = FORMAT_MAP[sourceSel];
    if (!fmt || shouldHideValue(value)) return value;
    if (fmt === 'money')   return formatMoney(value);
    if (fmt === 'percent') return formatPercent(value);
    return value;
  }

  function syncPairs() {
    var emiteFactura = isEmiteFactura();

    var pairs = [
      ['#valor_inicial_enviado',           '#valor_inicial_recibido'],
      ['#precio_venta_enviado',            '#precio_venta_recibido'],
      ['#factor_correccion_enviado',       '#factor_correccion_recibido'],
      ['#base_imponible_enviado',          '#base_imponible_recibido'],
      ['#tipo_impositivo_enviado',         '#tipo_impositivo_recibido'],
      ['#itp_enviado',                     '#itp_recibido'],
      ['#tasa_transfer_dgt_enviado',       '#tasa_transfer_dgt_recibido'],
      ['#tasa_informe_dgt_enviado',        '#tasa_informe_dgt_recibido'],
      ['#gestion_tramitacion_enviado',     '#gestion_tramitacion_recibido'],
      ['#total_enviado',                   '#total_recibido'],
    ];

    for (var i = 0; i < pairs.length; i++) {
      var sourceSel = pairs[i][0];
      var targetSel = pairs[i][1];

      var value = getValueFrom(sourceSel);

      if (emiteFactura) {
        if (sourceSel === '#itp_enviado') {
          value = '0';
        }
        // total_enviado ya lleva el ajuste calculado por form-imp-transferencia.js
      }

      setValueTo(targetSel, applyFormat(sourceSel, value));
    }

    updateRowsVisibility();
  }

  document.addEventListener('DOMContentLoaded', function () {
    window.syncPairs = syncPairs;

    // Agrupa ráfagas de eventos (ej: clearVehicleHiddenFields dispara ~45 eventos)
    // en una sola ejecución de syncPairs tras 20 ms de silencio.
    var syncPairsTimer = null;
    function debouncedSyncPairs() {
      clearTimeout(syncPairsTimer);
      syncPairsTimer = setTimeout(syncPairs, 20);
    }

    // Inicial
    syncPairs();

    // Eventos del formulario
    var form = document.querySelector('form.jet-form-builder') || document.body;
    form.addEventListener('input',  debouncedSyncPairs, true);
    form.addEventListener('change', debouncedSyncPairs, true);

    // El setInterval cubre re-renders de JFB sin necesidad de MutationObserver
    setInterval(syncPairs, 500);

    // Ocultar .calculo-itp dentro de .presupuesto-flotante cuando
    // .form-informe-vehiculo coexiste en la misma página.
    // Ambos elementos pueden aparecer tarde (JFB los renderiza de forma asíncrona),
    // así que el observer vigila hasta encontrar los dos.
    function tryHideCalculoItp() {
      var hayInforme = document.querySelector('.form_informe_vehiculo');
      if (!hayInforme) return false;

      var calculo = document.querySelector('.wp-block-group.calculo-itp.no-margin.is-layout-constrained.wp-block-group-is-layout-constrained');
      if (!calculo) { console.log('[ITP] .calculo-itp no encontrado aún'); return false; }

      calculo.style.setProperty('display', 'none', 'important');
      return true;
    }

    if (!tryHideCalculoItp()) {
      var itpObs = new MutationObserver(function () {
        if (tryHideCalculoItp()) itpObs.disconnect();
      });
      itpObs.observe(document.body, { childList: true, subtree: true });
    }
  });
})();



// WEBPACK FOOTER //
// ./scripts/routes/presupuesto-flotante.js